import React, { useEffect } from 'react';
import http from '../services/http/interceptors';
import { useNavigate } from 'react-router-dom';
import { Header } from "../components/header"

import { Calls }         from "../widgets/calls"
import { Tweets }        from '../widgets/tweets'
import { Tokens }        from '../widgets/tokens'
import { TokenEvents }   from '../widgets/tokenEvents'
import { Pumpfun }   from '../widgets/pumpfun'
import { Raydium }   from '../widgets/raydium'
import { Uniswap }   from '../widgets/uniswap'
import { UniswapEvents }   from '../widgets/uniswapEvents'
import { RaydiumEvents }   from '../widgets/raydiumEvents'
import { PumpfunEvents }   from '../widgets/pumpfunEvents'

import { MuuriComponent } from "muuri-react"
import { useSelector , useDispatch } from 'react-redux'
import { fetchData } from '../redux/actions'

export const Senshi = () => {
  const navigateTo = useNavigate();

  const _insights  =  JSON.parse(localStorage.getItem("insights5")) !== null 
                   ?  JSON.parse(localStorage.getItem("insights5"))   
                   :  [


                        {
                          name: 'Ethereum Signals',
                          type: 'ethereum_signals',
                          active: true
                        },

                        {
                          name: 'Uniswap Live Pairs',
                          type: 'uniswap_pairs',
                          active: true
                        },

                        {
                          name: 'Pumpfun Signals',
                          type: 'pumpfun_signals',
                          active: true
                        },
                        {
                          name: 'Pumpfun Live Pairs',
                          type: 'pumpfun_pairs',
                          active: true
                        },

                        {
                          name: 'Solana Signals',
                          type: 'solana_signals',
                          active: true
                        },                        
                        {
                          name: 'Raydium Live Pairs',
                          type: 'raydium_pairs',
                          active: true
                        },
                        {
                          name: 'Telegram Influencers',
                          type: 'telegram',
                          active: true
                        },
                                                {
                          name: 'Tweets',
                          type: 'tweets',
                          active: true
                        }
                      ]
              

  const _twitter   =  JSON.parse(localStorage.getItem("twitter5")) !== null 
                   ?  JSON.parse(localStorage.getItem("twitter5")) 
                   :  [
                        {
                          name: 'Elon Musk',
                          username: 'elonmusk',
                          active: true
                        },
                        {
                          name: 'Trump',
                          username: 'trump',
                          active: true
                        },
                      ]



  const _telegram  =  JSON.parse(localStorage.getItem("telegram5")) !== null 
                   ?  JSON.parse(localStorage.getItem("telegram5")) 
                   :  [

                    {
                      "name": "Wat is des",
                      "username": "@watisdes",
                      "active": true
                    },
  {
    "name": "Pow's Gem Calls",
    "username": "PowsGemCalls",
    "active": true
  },

  {
    "name": "OverDose Gems Calls",
    "username": "overdose_gems_calls",
    "active": true
  }
]

  const [tokenAddress, setTokenAddress] = React.useState('')

const [insights, setInsights] = React.useState(_insights)
const [twitter, setTwitter]   = React.useState(_twitter)
const [telegram, setTelegram] = React.useState(_telegram)

    const state = useSelector((state) => {
        return state
    }); 
    const dispatch = useDispatch()
    


    useEffect(() => { 
        // initial render  
          if (state.data.length === 0) {   
            dispatch(fetchData())
          }
    // timer 
    if ( state.data.length !==0  ) {
     let timer = setTimeout ( ()=> {     
        dispatch(fetchData())
       }, 10000)
    
       return()=> { 
         clearInterval(timer)
      }
    }
    
    }, [state.fetchCounter])

  const items = [

    {
      id: 3, 
      height: 2, 
      width: 30, 
      title: 'Pumpfun'
    },
        {
      id: 4, 
      height: 2, 
      width: 30, 
      title: 'Raydium'
    },
            {
      id: 5, 
      height: 2, 
      width: 30, 
      title: 'Uniswap'
    },
                            {
      id: 8, 
      height: 2, 
      width: 30, 
      title: 'Pumpfun Signals'
    },

                        {
      id: 7, 
      height: 2, 
      width: 30, 
      title: 'Solana Signals'
    },
                  {
      id: 6, 
      height: 2, 
      width: 30, 
      title: 'Ethereum Signals'
    }


  


  ];


  function isChad() {
    if (localStorage.getItem('access_token') === null || localStorage.getItem('refresh_token') === null) {
      // navigateTo('/login')
    }
  }

  useEffect(() => {
    /*
    http.get('/data').catch((err) => {
      if (err.response.status === 401) navigateTo('/login');
    });
    isChad()
    */
  }, []);

  console.log('state', state.data.tokens)

  let pumpfunTokens = []
  let raydiumTokens = []
  let uniswapTokens = []

  if (state !== undefined && state.data.length > 0) {

    pumpfunTokens = state.data.tokens.filter(x => x.platform === 'pumpfun')
    // console.log('pumpfunTokens', pumpfunTokens)

    raydiumTokens = state.data.tokens.filter(x => x.platform === 'solana')
    // console.log('raydiumTokens', raydiumTokens)

    uniswapTokens = state.data.tokens.filter(x => x.platform === 'ethereum')
    // console.log('uniswapTokens', uniswapTokens)

  }

  const children = items.map(props => 


            props.title === 'Pumpfun'
            ? <Pumpfun key={props.id} {...props} tokenEvents={state.data.tokens} />
              : props.title === 'Raydium' 
                ? <Raydium key={props.id} {...props} tokenEvents={state.data.tokens} />
                  : props.title === 'Uniswap' 
                    ? <Uniswap key={props.id} {...props} tokenEvents={state.data.tokens} /> 


    : props.title === 'Calls' 
    ? <Calls key={props.id} {...props} calls={state.data.posts} /> 
    : props.title === 'Tweets' 
      ? <Tweets key={props.id} {...props} tweets={state.data.tweets} /> 
      : props.title === 'TokenEvents' 
        ? <TokenEvents key={props.id} {...props} tokenEvents={state.data.insights} />

                      : props.title === 'Ethereum Signals'
                        ? <UniswapEvents key={props.id} {...props} tokenEvents={state.data.insights} /> 
                          : props.title === 'Solana Signals'
                            ? <RaydiumEvents key={props.id} {...props} tokenEvents={state.data.insights} />
                              : props.title === 'Pumpfun Signals' && <PumpfunEvents key={props.id} {...props} tokenEvents={state.data.insights} />)

  return (
    <section>
      <Header />
      <div class="row">
        <div class="sidebar" style={{display: 'none'}}>
          <div className="alpha">
            <span className="title">Degen Widgets</span>
            <div className="line" />
            {insights.map(i => {
              return (
                <div>
                  <span className="type">{i.name}</span>
                  <label className="switch">            
                    <input type="checkbox" checked={i.active} onChange={(e) => {
                      setInsights(insights.map(item => {
                        if (item.name === i.name) {
                          item.active = !i.active
                        }
                        return item;
                      }))
                      localStorage.setItem("insights5", JSON.stringify(insights))
                    }} />
                    <span className="slider round"></span>
                  </label>
                </div>)
            })}
          </div>

{/*
          <div className="alpha">
            <span className="title">Tweeties</span>
            <div className="line" />
            {twitter.map(i => {
              return (
                <div>
                  <span className="type">{i.name}</span>
                  <label className="switch">            
                    <input type="checkbox" checked={i.active} onChange={(e) => {
                      setTwitter(twitter.map(item => {
                        if (item.name === i.name) {
                          item.active = !i.active
                        }
                        return item;
                      }))
                      localStorage.setItem("twitter5", JSON.stringify(twitter))
                    }} />
                    <span className="slider round"></span>
                  </label>
                </div>)
            })}
          </div>

          <div className="alpha">
            <span className="title">Call Channels</span>
            <div className="line" />
            {telegram.map(i => {
              return (
                <div>
                  <span className="type">{i.name}</span>
                  <label className="switch">            
                    <input type="checkbox" checked={i.active} onChange={(e) => {
                      setTelegram(telegram.map(item => {
                        if (item.name === i.name) {
                          item.active = !i.active
                        }
                        return item;
                      }))
                      localStorage.setItem("telegram5", JSON.stringify(telegram))
                    }} />
                    <span className="slider round"></span>
                  </label>
                </div>)
            })}
          </div>


*/}
        </div>
        <div class="main">
          <MuuriComponent dragEnabled dragHandle=".handle">{children}</MuuriComponent>
        </div>
      </div>
    </section>
  )

}